import React from 'react';
import { Flex } from '@cko/primitives';
import PageSelector from './PageSelector';
import ZoomSelector from './ZoomSelector';
import { TruncateWord } from '../../TruncateWord';
const PdfToolbar = (props) => {
    const { isDisabled = false, onClickPreviousPage, onClickNextPage, onZoomChange, page, pageCount, title, zoom, } = props;
    return (React.createElement(Flex, { alignItems: "center", backgroundColor: "var(--base-bg-secondary)", color: "var(--base-bg-primary)", justifyContent: "space-between", minHeight: "50px", padding: "var(--layout-seed) var(--layout-spoon)", width: "100%" },
        React.createElement(Flex, { flex: "1", maxWidth: "33%" },
            React.createElement(TruncateWord, { color: "var(--base-text-primary)", "data-testid": "pdf-viewer-toolbar-title", fontWeight: "500", overflow: "hidden" }, title)),
        React.createElement(PageSelector, { isDisabled: isDisabled, onClickNextPage: onClickNextPage, onClickPreviousPage: onClickPreviousPage, page: page, pageCount: pageCount }),
        React.createElement(Flex, { flex: "1", justifyContent: "flex-end", maxWidth: "33%" },
            React.createElement(ZoomSelector, { isDisabled: isDisabled, onZoomChange: onZoomChange, zoom: zoom }))));
};
export default PdfToolbar;
